import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { Socket } from 'ngx-socket-io';

declare const $:any;

/* Marcador del partido para ponerlo encima de la transmision (fuente "Web" de Prism Live Studio u OBS).
   Es el enlace que copia Rol de Partidos. El fondo queda transparente para que solo se vea la franja
   sobre la camara. El marcador lo manda en vivo la planilla de la tablet: la pagina entra a la sala
   del partido en el servidor y, al abrirse o reconectarse, le pide a la tablet el marcador actual,
   porque en la base recien queda al procesar el cierre. El logo del campeonato va arriba a la derecha.
   Con ?posicion=abajo la franja va al pie y con ?logo=izquierda el logo pasa a la esquina izquierda
   (se pueden juntar: ?posicion=abajo&logo=izquierda). Cada gol, canasta o set que anota la tablet se
   anuncia con una tarjeta animada bajo la franja; ?animacion=no la apaga. */
@Component({
    selector: 'app-consulta-marcador-partido',
    templateUrl: './consulta-marcador-partido.component.html',
    styleUrls: ['./consulta-marcador-partido.component.css'],
    standalone: false
})
export class ConsultaMarcadorPartidoComponent extends BaseComponent implements OnInit, OnDestroy {

  id_partido:any;
  partido:any;
  //lo ultimo que mando la tablet; mientras no llegue nada se muestra lo que hay en la base
  vivo:any=null;
  posicion='arriba';
  //logo del campeonato en la esquina superior derecha, o la izquierda con ?logo=izquierda
  campeonato:any=null;
  esquina_logo='derecha';
  //resalta un momento el numero que cambio
  destello=[false,false];
  logo_fallido=[false,false];
  //tarjeta de la jugada (gol, canasta, set): la que se esta mostrando y la ultima ya vista
  animacion=true;
  jugada:any=null;
  mostrar_jugada=false;
  private id_ultima_jugada:any=null;
  private temporizador_jugada:any=null;
  private suscripciones:Subscription[]=[];
  private temporizadores:any[]=[];

  constructor(private _Activatedroute:ActivatedRoute,
    private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    public rolesPartidosService:RolesPartidosService,
    public socket:Socket) {
      super(persistenciaService,modalService,generalService,usuarioService);
     }

  ngOnInit(): void {
    $('html, body, .body-container').css({'background-image':'none','background-color':'transparent'});
    this.id_partido=this._Activatedroute.snapshot.paramMap.get("id_partido");
    this.posicion=this._Activatedroute.snapshot.queryParamMap.get("posicion")=="abajo"?"abajo":"arriba";
    this.esquina_logo=this._Activatedroute.snapshot.queryParamMap.get("logo")=="izquierda"?"izquierda":"derecha";
    this.animacion=this._Activatedroute.snapshot.queryParamMap.get("animacion")!="no";
    this.obtenerPartido();
    this.obtenerCampeonato();
    let entrar=() => {
      this.socket.emit('unirseMarcadorPartido',{id_partido:Number(this.id_partido)});
      this.socket.emit('pedirMarcadorEnVivo',{id_partido:Number(this.id_partido)});
    };
    this.suscripciones.push(
      this.socket.fromEvent('connect').subscribe(() => entrar()),
      this.socket.fromEvent('marcadorEnVivo').subscribe((dato:any) => this.recibirMarcador(dato))
    );
    if(this.socket.ioSocket?.connected) entrar();
  }

  ngOnDestroy(): void {
    this.suscripciones.forEach(suscripcion => suscripcion.unsubscribe());
    this.temporizadores.forEach(temporizador => clearTimeout(temporizador));
    clearTimeout(this.temporizador_jugada);
    this.socket.emit('salirMarcadorPartido',{id_partido:Number(this.id_partido)});
  }

  //sin blockUI: la pagina va dentro de la transmision
  obtenerPartido(){
    this.rolesPartidosService.obtenerPartido(this.id_partido).subscribe((res:any)=>{
      if(res && !res.tiene_error) this.partido=res;
    });
  }

  obtenerCampeonato(){
    this.rolesPartidosService.obtenerCampeonatoPartido(this.id_partido).subscribe((res:any)=>{
      if(res && !res.tiene_error) this.campeonato=res;
    });
  }

  logoCampeonato(){
    return this.campeonato && this.campeonato.logo?this.rest_server+this.campeonato.logo:null;
  }

  recibirMarcador(dato){
    if(!dato || dato.id_partido!=this.id_partido) return;
    let anterior=[this.marcador(0),this.marcador(1)];
    this.vivo=dato;
    [0,1].forEach(lado => {
      if(anterior[lado]!==null && anterior[lado]!==this.marcador(lado)) this.destellar(lado);
    });
    this.recibirJugada(dato.jugada);
  }

  /* La tablet manda siempre la ultima jugada junto al marcador. Se anuncia solo si no se vio antes y es
     reciente (hace_ms lo mide la tablet con su propio reloj): asi, al recargar la pagina o al volver la
     senal, no se festeja un gol de hace minutos. Una jugada nueva reemplaza a la que se esta mostrando,
     para no atrasarse con las canastas seguidas del baloncesto. */
  recibirJugada(jugada){
    if(!jugada || jugada.id==this.id_ultima_jugada) return;
    this.id_ultima_jugada=jugada.id;
    if(!this.animacion || !(jugada.hace_ms<12000)) return;
    clearTimeout(this.temporizador_jugada);
    this.mostrar_jugada=false;
    this.temporizador_jugada=setTimeout(() => {
      this.jugada=jugada;
      this.mostrar_jugada=true;
      this.temporizador_jugada=setTimeout(() => this.mostrar_jugada=false,4500);
    },30);
  }

  tituloJugada(){
    let jugada=this.jugada;
    if(!jugada) return '';
    switch(jugada.tipo){
      case 'gol': return '¡GOL!';
      case 'canasta': return '+'+jugada.puntos;
      case 'anulado': return 'ANULADO';
      case 'set': return 'SET';
      case 'final': return 'FINAL';
      case 'set_point': return 'SET POINT';
      case 'match_point': return 'MATCH POINT';
      case 'amarilla': return 'AMARILLA';
      case 'doble_amarilla': return 'DOBLE AMARILLA';
      case 'roja': return 'ROJA';
      case 'sancion': return this.SANCIONES_VOLEIBOL[jugada.detalle]?.titulo || 'SANCIÓN';
    }
    return '';
  }

  //sanciones de voleibol como las anota la planilla: amonestacion (amarilla), castigo (roja, punto al rival),
  //expulsion (fuera del set) y descalificacion (fuera del partido)
  readonly SANCIONES_VOLEIBOL={
    A:{titulo:'AMONESTACIÓN',detalle:'tarjeta amarilla',color:'amarilla'},
    C:{titulo:'CASTIGO',detalle:'punto para el rival',color:'roja'},
    E:{titulo:'EXPULSIÓN',detalle:'fuera por el resto del set',color:'roja'},
    D:{titulo:'DESCALIFICADO',detalle:'fuera del partido',color:'roja'}
  };

  //el color de la tarjeta: amarilla para las amonestaciones, roja para expulsiones y castigos
  colorTarjeta(){
    let jugada=this.jugada;
    if(!jugada) return '';
    if(jugada.tipo=='amarilla') return 'amarilla';
    if(jugada.tipo=='doble_amarilla' || jugada.tipo=='roja') return 'roja';
    if(jugada.tipo=='sancion') return this.SANCIONES_VOLEIBOL[jugada.detalle]?.color || 'amarilla';
    return '';
  }

  readonly TEXTO_ANULADO={gol:'gol anulado',canasta:'canasta anulada',amarilla:'amarilla anulada',
                          roja:'roja anulada',sancion:'sanción anulada'};

  //el jugador como "Nº 10 · PEREZ"; sin jugador (gol sin autor, voleibol) el nombre del equipo
  protagonistaJugada(){
    let jugada=this.jugada;
    if(!jugada) return '';
    if(jugada.apellido) return (jugada.numero?'Nº '+jugada.numero+' · ':'')+jugada.apellido;
    return this.nombreEquipo(jugada.equipo);
  }

  detalleJugada(){
    let jugada=this.jugada;
    if(!jugada) return '';
    let partes=[];
    if(jugada.apellido) partes.push(this.nombreEquipo(jugada.equipo));
    if(jugada.tipo=='canasta') partes.push(jugada.puntos==3?'TRIPLE':jugada.puntos==1?'TIRO LIBRE':'DOBLE');
    if(jugada.tipo=='anulado') partes.push(this.TEXTO_ANULADO[jugada.detalle] || 'gol anulado');
    if(jugada.tipo=='doble_amarilla' || jugada.tipo=='roja') partes.push('expulsado');
    if(jugada.tipo=='sancion' && this.SANCIONES_VOLEIBOL[jugada.detalle]) partes.push(this.SANCIONES_VOLEIBOL[jugada.detalle].detalle);
    if(jugada.tipo=='gol' && !jugada.apellido) partes.push('gol');
    if(jugada.tipo=='final') partes.push('gana el partido');
    if(jugada.detalle && jugada.tipo!='anulado' && jugada.tipo!='sancion') partes.push(jugada.detalle);
    if(jugada.momento) partes.push(jugada.momento);
    return partes.join(' · ');
  }

  destellar(lado){
    this.destello[lado]=false;
    this.temporizadores.push(setTimeout(() => {
      this.destello[lado]=true;
      this.temporizadores.push(setTimeout(() => this.destello[lado]=false,1200));
    },0));
  }

  equipo(lado){
    return this.partido?(lado==0?this.partido.equipo_1:this.partido.equipo_2):null;
  }

  nombreEquipo(lado){
    let equipo=this.equipo(lado);
    if(equipo && equipo.nombre) return equipo.nombre;
    return this.vivo?(lado==0?this.vivo.equipo_1.nombre:this.vivo.equipo_2.nombre):'';
  }

  logoEquipo(lado){
    let equipo=this.equipo(lado);
    return equipo && equipo.logo && !this.logo_fallido[lado]?this.rest_server+equipo.logo:null;
  }

  //un logo que no carga no se muestra: en la transmision saldria el icono de imagen rota
  logoFallido(lado){
    this.logo_fallido[lado]=true;
  }

  marcador(lado){
    let fuente=this.vivo || this.partido;
    if(!fuente) return null;
    let valor=lado==0?fuente.marcador_equipo_1:fuente.marcador_equipo_2;
    return valor===null || valor===undefined?null:Number(valor);
  }

  esVoleibol(){
    return this.vivo?this.vivo.disciplina=="VOLEIBOL":false;
  }

  /* Debajo del marcador: el periodo en juego ("2º tiempo", "3º cuarto") o, en voleibol, el set con sus
     puntos (el marcador grande son los sets ganados). Solo con datos de la tablet. */
  textoPeriodo(){
    if(!this.vivo) return '';
    if(this.vivo.terminado) return 'FINAL';
    if(this.esVoleibol()) return this.vivo.periodo+' · '+(this.vivo.puntos_set_equipo_1 ?? 0)+' - '+(this.vivo.puntos_set_equipo_2 ?? 0);
    return this.vivo.periodo || '';
  }

}
